module.exports = __webpack_public_path__ + "img/topicHiTech.fd8e7ef5.svg";